export const TIME_OFF_STATUS = Object.freeze({
  1: {
    title: 'Pending', // initial
    color: '#3b82f6'
  },
  2: {
    title: 'Days Verified', // days_accepted
    color: '#10b981'
  },
  3: {
    title: 'Approved', // accepted
    color: '#10b981'
  },
  4: {
    title: 'Declined', // declined
    color: '#ef4444'
  }
})

export const TIME_OFF_TYPE = Object.freeze({
  1: {
    title: 'Sick',
    color: '#3b82f6'
  },
  2: {
    title: 'Vacation',
    color: '#6C69FF'
  },
  3: {
    title: 'Personal',
    color: '#6b7280'
  },
  4: {
    title: 'Other',
    color: '#6b7280'
  }
})

export const TIME_OFF_REQUEST_TYPE = Object.freeze({
  1: {
    title: 'Absence Report',
    color: '#ef4444'
  },
  2: {
    title: 'Time Off Request',
    color: '#10b981'
  }
})
